import { Configurer } from '../Core/index';
import { Echo } from './Echo';

/**Echo*/
export class EchoConfigurer extends Configurer {}
